import QuestionHelp from '@/components/QuestionHelp/index.vue'

import QuestionHelpLabel from '@/components/QuestionHelpLabel/index.vue'
import TableOverflowText from '@/components/TableOverflowText/index.vue'
import UnifiedTableColumn from '@/components/UnifiedTableColumn'
// 加载 iconify 图标
import { downloadAndInstall } from '@/iconify'

import icons from '@/iconify/index.json'

// 自定义指令
import directive from '@/utils/directive'
// 错误日志上报
import errorLog from '@/utils/error.log'
// Tinymce 编辑器
import TinymceEditor from '@tinymce/tinymce-vue'
import VWave from 'v-wave'
import App from './App.vue'
import i18n from './locales'
import router from './router'

import pinia from './store'
import uiProvider from './ui/provider'

import 'tinymce/tinymce'
import 'tinymce/themes/silver/theme'
import 'tinymce/icons/default/icons'
import 'tinymce/models/dom'
import 'tinymce/plugins/autolink'
import 'tinymce/plugins/autoresize'
import 'tinymce/plugins/fullscreen'
import 'tinymce/plugins/image'
import 'tinymce/plugins/insertdatetime'
import 'tinymce/plugins/link'
import 'tinymce/plugins/lists'

import 'tinymce/plugins/media'
import 'tinymce/plugins/preview'

import 'tinymce/plugins/table'
import 'tinymce/plugins/wordcount'
import 'tinymce/plugins/code'

import 'tinymce/plugins/searchreplace'

import '@/utils/systemCopyright'
// 加载 svg 图标
import 'virtual:svg-icons-register'
import 'virtual:uno.css'
import '@unocss/reset/tailwind-compat.css'

// 全局样式
import '@/assets/styles/globals.css'
import '@/assets/styles/form-controls.css'
import '@/assets/styles/table.css'
import '@/assets/styles/detail-dialog.css'

const app = createApp(App)
app.use(VWave, {})
app.use(pinia)
app.use(router)
app.use(uiProvider)
app.use(i18n)
app.component('ElTableColumn', UnifiedTableColumn)
app.component('TinymceEditor', TinymceEditor)
app.component('QuestionHelp', QuestionHelp)
app.component('QuestionHelpLabel', QuestionHelpLabel)
app.component('TableOverflowText', TableOverflowText)
directive(app)
errorLog(app)
if (icons.isOfflineUse) {
  for (const info of icons.collections) {
    downloadAndInstall(info)
  }
}

app.mount('#app')
